//containers
import { reduxForm, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { fetchMeasurementUnit, editMeasurementUnit, clearMeasurementUnitEdited, deleteMeasurementUnit } from '../../actions/products_actions';
import { MeasurementUnit } from '../../components/Products/measurementUnit';

let measurementUnit = reduxForm({
  form: 'measurementUnit',
})(MeasurementUnit);

function mapStateToProps(state) {
  return {
    measurementUnitFetched: state.products.measurementUnitFetched,
    fetchingMeasurementUnit: state.products.fetchingMeasurementUnit,
    measurementUnitFetchError: state.products.measurementUnitFetchError,
    editingMeasurementUnit: state.products.editingMeasurementUnit,
    measurementUnitEdited: state.products.measurementUnitEdited,
    measurementUnitEditError: state.products.measurementUnitEditError,
    deletingMeasurementUnit: state.products.deletingMeasurementUnit,
    deleteMeasurementUnitSuccess: state.products.deleteMeasurementUnitSuccess,
    deleteMeasurementUnitError: state.products.deleteMeasurementUnitError,
  }
}

export default connect(mapStateToProps, {
  fetchMeasurementUnit, editMeasurementUnit, clearMeasurementUnitEdited, deleteMeasurementUnit
})(measurementUnit)



// WEBPACK FOOTER //
// ./master/jsx/containers/Products/measurementUnit.jsx